import { render, staticRenderFns } from "./ProjectIndex.vue?vue&type=template&id=5b4a6ead&"
import script from "./ProjectIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports